// Why Choose Us Swiper (Mobile Only)
function initWhyChooseUsSwiper() {
    const swiperEl = document.querySelector('.why-choose-us-swiper');
    if (window.innerWidth < 768 && swiperEl) {
        if (!window.whyChooseUsSwiper) {
            const sliderWrap = swiperEl.closest('.why-choose-us__slider-wrap');
            window.whyChooseUsSwiper = new Swiper(swiperEl, {
                slidesPerView: 1.5,
                spaceBetween: 12,
                centeredSlides: false,
                pagination: false,
                navigation: {
                    nextEl: sliderWrap?.querySelector('.why-choose-us__nav-btn--next'),
                    prevEl: sliderWrap?.querySelector('.why-choose-us__nav-btn--prev'),
                },
                autoHeight: false,
                observer: true,
                observeParents: true,
                resizeObserver: true,
                watchOverflow: true,
            });
        } else {
            window.whyChooseUsSwiper.update();
        }
    } else {
        if (window.whyChooseUsSwiper) {
            window.whyChooseUsSwiper.destroy(true, true);
            window.whyChooseUsSwiper = null;
        }
    }
}

// Our Moments Swiper (viewport < 1024px — trùng breakpoint desktop-only / mobile-only)
function initMomentsSwiper() {
    const el = document.querySelector('.our-moments .momentsSwiper');
    if (!el) return;

    if (window.innerWidth < 1024) {
        if (!window.ourMomentsSwiperInstance) {
            window.ourMomentsSwiperInstance = new Swiper(el, {
                slidesPerView: 1.4,
                spaceBetween: 15,
                centeredSlides: true,
                loop: true,
                observer: true,
                observeParents: true,
                speed: 600,
                breakpoints: {
                    640: {
                        slidesPerView: 2.2,
                    },
                },
            });
        }
    } else if (window.ourMomentsSwiperInstance) {
        window.ourMomentsSwiperInstance.destroy(true, true);
        window.ourMomentsSwiperInstance = null;
    }
}

// Mobile Menu Toggle Slide (Accordion)
function initMobileMenuAccordion() {
    const toggles = document.querySelectorAll('.js-mobile-toggle');
    
    toggles.forEach(toggle => {
        // Gỡ bỏ event cũ nếu có (tránh trùng lặp khi resize)
        toggle.removeEventListener('click', handleMobileToggle);
        toggle.addEventListener('click', handleMobileToggle);
    });
}

function handleMobileToggle(e) {
    e.preventDefault();
    e.stopImmediatePropagation(); // Cực kỳ quan trọng: Ngăn chặn theme.js đóng menu

    const button = e.currentTarget;
    const wrapper = button.closest('.mobile-toggle-wrapper');
    const content = wrapper.querySelector('.menu-drawer__submenu-collapsible');

    if (!wrapper || !content) return;

    const isOpen = wrapper.classList.contains('is-open');

    if (isOpen) {
        content.style.maxHeight = content.scrollHeight + 'px';
        setTimeout(() => {
            content.style.maxHeight = '0';
            wrapper.classList.remove('is-open');
        }, 10);
    } else {
        wrapper.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
        
        content.addEventListener('transitionend', function handler() {
            if (wrapper.classList.contains('is-open')) {
                content.style.maxHeight = 'fit-content';
            }
            content.removeEventListener('transitionend', handler);
        });
    }
    button.setAttribute('aria-expanded', !isOpen);
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    initWhyChooseUsSwiper();
    initMomentsSwiper();
    initMobileMenuAccordion();
});

// Handle resize
window.addEventListener('resize', function() {
    initWhyChooseUsSwiper();
    initMomentsSwiper();
    // Không nhất thiết phải init lại menu khi resize trừ khi cấu trúc DOM thay đổi
});


document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.custom-mobile-drawer');
  const openBtn = document.querySelector('.js-drawer-open-btn');
  const closeBtns = document.querySelectorAll('.js-drawer-close-btn');
  const toggles = document.querySelectorAll('.js-mobile-toggle');

  if (openBtn) {
    openBtn.addEventListener('click', () => {
      container.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  closeBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      container.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  });

  toggles.forEach(toggle => {
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const wrapper = this.closest('.mobile-toggle-wrapper');
      const content = wrapper.querySelector('.menu-drawer__submenu-collapsible');

      if (wrapper.classList.contains('is-active')) {
        content.style.maxHeight = null;
        wrapper.classList.remove('is-active');
      } else {
        wrapper.classList.add('is-active');
        content.style.maxHeight = content.scrollHeight + "px";
        
        // Cập nhật chiều cao cho menu cha nếu đang ở cấp sâu hơn
        const parentCollapsible = wrapper.parentElement.closest('.menu-drawer__submenu-collapsible');
        if (parentCollapsible) {
          parentCollapsible.style.maxHeight = (parentCollapsible.scrollHeight + content.scrollHeight) + "px";
        }
      }
    });
  });
});